/***
     *
     * promise 二次封装请求
     */
import axios from "axios";
// 一些请求的基本配置
import config from '@/utils/config'
const service = axios.create({
  // baseURL: "https://3z714i9315.imdo.co/", // 测试地址
  baseURL: config.baseUrl,
  headers: {
    "Content-Type": "application/json",
  }
});

service.interceptors.request.use(config => {
  const Authorization = sessionStorage.getItem("Token") || "";
  if (!config.headers.Authorization) {
    config.headers.Authorization = Authorization
  }
  return config
})

// 输出方法
function request(url, data = {}, method = "post") {  // 如果此处的method为get 则需要传入get，默认为post
  return new Promise((resolve, reject) => {
    const options = {
      url,
      method
    };
    if (method.toLowerCase() === "get") {
      options.params = data;		//如果为get传参为params
    } else {
      options.data = data;   //  post等 传数据为data
    }
    service(options)
      .then(res => {
        resolve(res.data);   //返回数据
      })
      .catch(error => {
        reject();
        console.error("error", error);  //异常捕获
      });
  });
}

export default request




// WEBPACK FOOTER //
// ./src/utils/request.js